"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClinicalGrounding() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section data-section-id="33735" id="hero" className="relative min-h-[45vh] flex items-center justify-center overflow-hidden bg-white">
      <style>{`
        @keyframes slow-zoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.1); }
        }
        .animate-slow-zoom {
          animation: slow-zoom 20s ease-in-out infinite alternate;
        }
      `}</style>

      {/* Image de fond */}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/nebraska_cornfield_golden_hour.png" alt="Réunion professionnelle et collaboration" className={`w-full h-full object-cover transition-opacity duration-1000 ${isMounted ? "opacity-100 animate-slow-zoom" : "opacity-0"}`} />
        <div className="absolute inset-0 bg-white/60 mix-blend-normal" />
        <div className="absolute inset-0 bg-slate-50/10" />
      </div>

      {/* Contenu */}
      <div className="relative z-10 container mx-auto px-4 py-12 lg:py-16 flex justify-center">
        <div ref={ref} className={`
            max-w-4xl w-full mx-auto text-center p-8 md:p-12 rounded-sm
            backdrop-blur-md bg-white/80 border border-slate-100 shadow-xl
            transform transition-all duration-1000 ease-out
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}
          `}>
          <h1 className="text-3xl font-bold mb-4 tracking-tight font-serif leading-tight !text-[hsl(343,80%,35%)] md:text-4xl lg:text-5xl">
            Échangeons sur votre projet
          </h1>

          <p className="text-base md:text-lg text-[hsl(343,80%,35%)]/80 mb-4 font-serif italic max-w-2xl mx-auto">
            <strong className="font-semibold not-italic">Christelle CHARRIER-ROBELIN</strong> se
            tient à votre disposition pour échanger sur votre projet en toute
            confidentialité.
          </p>

          <p className="text-base md:text-lg text-slate-700 mb-8 leading-relaxed max-w-2xl mx-auto font-sans">
            Vous avez un projet de certification RNCP/RS, un audit Qualiopi® à
            préparer, ou des questions sur la conformité réglementaire de votre
            activité formation ? Prenons contact pour échanger sur vos enjeux et
            la manière dont Effet Conseil peut vous accompagner.
          </p>
        </div>
      </div>
    </section>;
}